import ListView from "../../component/ListView";
import {Column} from "primereact/column";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import SemPermissao from "../erro/SemPermissao";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";

function DiferencialList() {
    return (
        <>
            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}
                             forbiddenFallback={<SemPermissao />}>
                <ListView title={"Diferencial"}
                          id={`${process.env.REACT_APP_REST_DIFERENCIAL}`}>
                    <Column field="nomeDiferencial" header="Descrição" sortable />
                </ListView>
            </RoleBasedAccess>
        </>
    );
}

export default DiferencialList;